<template>
  <div>
    <v-card id="card-modal-assign-vehicle" class="elevation-4 ">
      <v-card-title class="justify-start py-2 card-modaltitle">
        <div class="pl-4">
          <h3 class="primary--text title--text">
            {{ $t("components.views.trip.no_offer_assign.modal_assign.assign") }}
          </h3>
        </div>
        <v-btn depressed text color="primary" class="cont" @click.stop="$emit('closeForm')">
          <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form v-model="valida" dense>
          <v-container fluid class="pl-2">
            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete v-model="company" url="/TransportCompany" item-text="businessName"
                  item-value="businessName" dense return-object prepend-icon="fa-solid fa-building" required
                  hide-details :label="$t('components.views.trip.no_offer_assign.modal_assign.business_transport')
                    " :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.business_transport')
                      " :rules="[
                        required(
                          $t('components.views.trip.no_offer_assign.modal_assign.business_transport'),
                          1
                        ),
                      ]" />
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete ref="driver" :selected="driver" @input="driver = $event" url="/Drivers" dense
                  return-object item-text="identification" item-value="identification" required
                  prepend-icon="fa-solid fa-id-card" :label="$t('components.views.trip.no_offer_assign.modal_assign.identification_number')
                    " :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.identification_number')
                      " :rules="[
                        required(
                          $t('components.views.trip.no_offer_assign.modal_assign.identification_number')
                        ),
                      ]" hide-details maxlength="15" :search-input.sync="driverCreate"
                  @click:clear="cleanFieldDriver()">
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewDriver()">
                      <v-list-item-title>{{
                        $t("components.views.trip.no_offer_assign.modal_assign.create_new_driver")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" class="pt-2 pb-0">
                <v-text-field v-model="driverNameComputed" required outlined dense readonly hide-details
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.names_last_names')" :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.names_last_names')
                    " prepend-icon="fa-solid fa-user" />
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="10" class="pb-0">
                <SelectAutocomplete ref="vehicle" v-model="vehicle" :url="urlVehicle" return-object dense
                  item-text="licensePlate" item-value="licensePlate" maxlength="10" :search-input.sync="vehicleCreate"
                  prepend-icon="fa-solid fa-truck-moving"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.license_plate')" required :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.license_plate')
                    " :rules="[
                      required(
                        $t('components.views.trip.no_offer_assign.modal_assign.license_plate'),
                        1
                      ),
                    ]" hide-details>
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewVehicle()">
                      <v-list-item-title>{{
                        $t("components.views.trip.no_offer_assign.modal_assign.create_new_vehicle")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
              <v-col cols="2" class="pt-7 pb-0">
                <v-tooltip bottom color="primary" v-if="userGPS !== undefined">
                  <template v-slot:activator="{ on, attrs }">
                    <div id="stateGPSColor" v-bind="attrs" :style="{
                      backgroundColor: backgroundColorStateGps,
                      color: colorFontStateGps,
                    }" style="background-color: gray; color: #fff" v-on="on">
                      GPS
                    </div>
                  </template>
                  <div id="info_gps">
                    <b>{{ $t("components.views.trip.no_offer_assign.modal_assign.user_gps") }} :
                    </b>
                    <span>{{ userGPS }}</span>
                    <br />
                    <b>{{ $t("components.views.trip.no_offer_assign.modal_assign.date_gps") }} :
                    </b>
                    <span>{{ dateLastGPS }}</span>
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <SelectAutocomplete ref="trailer" v-model="trailer" :data="filteredTrailers" :init="false" return-object
                  dense item-text="licensePlate" item-value="licensePlate" maxlength="10"
                  :search-input.sync="trailerCreate" prepend-icon="fa-solid fa-trailer"
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.trailer_plate')" :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.trailer_plate')
                    " hide-details clearable>
                  <template slot="no-data">
                    <v-list-item @click="loadModalNewTrailer()">
                      <v-list-item-title>{{
                        $t("components.views.trip.no_offer_assign.modal_assign.create_new_trailer")
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </SelectAutocomplete>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" class="pt-2 pb-0">
                <v-text-field v-model="typology" outlined readonly dense hide-details
                  :label="$t('components.views.trip.no_offer_assign.modal_assign.type_vehicle')" :placeholder="$t('components.views.trip.no_offer_assign.modal_assign.type_vehicle')
                    " prepend-icon="fa-solid fa-bullseye" />
              </v-col>
            </v-row>
            <v-row class="contaaner__btn pr-2">
              <v-col cols="6" class="pa-3">
                <v-btn color="secondary" style="height: 35px;" :disabled="!valida" @click="assign()" depressed block>
                  <v-icon class="mr-2" small>fa-solid fa-check</v-icon>
                  {{ $t("components.views.trip.no_offer_assign.modal_assign.assign") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogDriver" scrollable width="35%" persistent>
      <ModalCreateDriver :idDriver="driverCapture" :idCompany="idCompany" @closeForm="onCloseFormDriver()"
        @driverCreated="onDriverCreated" />
    </v-dialog>

    <v-dialog v-model="dialogVehicle" scrollable width="20%" persistent>
      <ModalCreateVehicle :idLicensePlate="vehicleCapture" :idCompany="idCompany" :key="index"
        @closeForm="onCloseFormVehicle()" @vehicleCreated="onVehicleCreated" />
    </v-dialog>

    <v-dialog v-model="dialogTrailer" scrollable width="20%" persistent>
      <ModalCreateTrailer :idLicensePlate="trailerCapture" :idCompany="idCompany" :key="index"
        @closeForm="onCloseFormTrailer()" @trailerCreated="onTrailerCreated" />
    </v-dialog>

    <!-- Modal de alerta de documentos vencidos del conductor -->
    <v-dialog v-model="dialogDocsAlert" scrollable width="40%" persistent>
      <DriverDocumentsAlertModal :driverName="docsAlertData.driverName" :documents="docsAlertData.documents"
        @close="onCloseDocsAlert" />
    </v-dialog>
    <v-dialog v-model="dialogVehicleDocsAlert" scrollable width="40%" persistent>
      <VehicleDocumentsAlertModal :licensePlate="vehicleDocsAlertData.licensePlate"
        :documents="vehicleDocsAlertData.documents" @close="onCloseVehicleDocsAlert" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import validate from "@/plugins/validate";
export default {
  components: {
    ModalCreateDriver: () =>
      import(
        /* webpackChunkName: "ModalCreateDriver" */ "@/components/views/Trip/NoOfferAssign/ModalCreateDriver.vue"
      ),
    ModalCreateVehicle: () =>
      import(
        /* webpackChunkName: "ModalCreateVehicle" */ "@/components/views/Trip/NoOfferAssign/ModalCreateVehicle.vue"
      ),
    ModalCreateTrailer: () =>
      import(
        /* webpackChunkName: "ModalCreateTrailer" */ "@/components/views/Trip/NoOfferAssign/ModalCreateTrailer.vue"
      ),
    DriverDocumentsAlertModal: () =>
      import(
        /* webpackChunkName: "DriverDocumentsAlertModal" */ "@/components/views/Trip/modals/DriverDocumentsAlertModal.vue"
      ),
    VehicleDocumentsAlertModal: () =>
      import(
        /* webpackChunkName: "VehicleDocumentsAlertModal" */ "@/components/views/Trip/modals/VehicleDocumentsAlertModal.vue"
      ),
  },
  props: {
    idMonitoringOrder: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      index: 1,
      ...validate,
      dialogDriver: false,
      dialogVehicle: false,
      dialogTrailer: false,
      dialogDocsAlert: false,
      docsAlertData: { driverName: '', documents: [] },
      dialogVehicleDocsAlert: false,
      vehicleDocsAlertData: { licensePlate: '', documents: [] },
      valida: false,
      typology: "",
      vehicle: {},
      gps: {},
      company: {},
      driverName: "",
      driverCreate: null,
      driverCapture: "",
      vehicleCreate: null,
      vehicleCapture: "",
      trailer: {},
      trailerCreate: null,
      trailerCapture: "",
      driver: {},
      allVehicles: [],
    };
  },
  computed: {
    dataProp: {
      get() {
        return this.data
          ? this.data
          : {
            id: "",
            idVehicle: "",
            licensePlate: "",
          };
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    backgroundColorStateGps() {
      return this.gps.stateGPS == 0
        ? "green"
        : this.gps.stateGPS == 1
          ? "yellow"
          : this.gps.stateGPS == 2
            ? "silver"
            : "silver";
    },
    ...mapGetters({
      user: "auth/user",
    }),
    idCompany() {
      let userMap = JSON.parse(this.user);
      return userMap.user.idCompany;
    },
    urlVehicle() {
      return `/Vehicles/${this.idMonitoringOrder}`;
    },
    colorFontStateGps() {
      return this.gps.stateGPS == 0
        ? "#FFFFFF"
        : this.gps.stateGPS == 1
          ? "#000000"
          : this.gps.stateGPS == 2
            ? "#FFFFFF"
            : "#FFFFFF";
    },
    userGPS() {
      return this.gps.username !== "" ? this.gps.username : this.dataProp.user_gps;
    },
    dateLastGPS() {
      return this.gps.dateGPS !== ""
        ? this.moment(new Date(this.gps.dateGPS)).format("DD-MM-YYYY hh:mm:ss")
        : this.dataProp.date_gps;
    },
    driverNameComputed() {
      return this.driverName !== "" ? this.driverName : this.dataProp.driver_name;
    },
    filteredTrailers() {
      return this.allVehicles.filter(vehicle => vehicle.idVehicleClass === 15);
    },
  },
  watch: {
    driver(newVal) {
      if (newVal) {
        this.driverName = this.driver.name + " " + this.driver.lastName;
        this.validateDriverCertificate();
      }
    },
    vehicle(newVal) {
      if (newVal && newVal.licensePlate) {
        this.dataProp.licensePlate = newVal.licensePlate;
        this.validateVehicleCertificate(newVal.licensePlate);
      } else {
        this.dataProp.licensePlate = "";
      }
      this.showTypeVehicle();
      this.showGpsVehicle();
    },
  },
  mounted() {
    this.loadAllVehicles();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("loader", ["showLoader"]),

    async validateVehicleCertificate(licensePlate) {
      try {
        const { validateVehicleCertificate: validateVehicleCertificateApi } = await import("@/components/validVehicle/validateVehicle.js");
        const result = await validateVehicleCertificateApi(this.axios, licensePlate, { idMonitoringOrder: this.idMonitoringOrder });
        if (result && result.shouldAlert) {
          this.showVehicleValidationAlert(licensePlate, result.documents);
        }
      } catch (error) {
        this.showSnack({ text: 'Error al validar el vehículo', title: 'Error', name: 'error' });
      }
    },
    showVehicleValidationAlert(licensePlate, documents) {
      this.vehicleDocsAlertData = { licensePlate, documents };
      this.dialogVehicleDocsAlert = true;
    },
    onCloseVehicleDocsAlert() {
      this.dialogVehicleDocsAlert = false;
      this.vehicle = null;
      this.dataProp.licensePlate = "";
      this.vehicleCreate = null;
    },

    async assign() {
      this.showLoader({
        show: true,
      });

      this.valida = false;

      let params = {
        idMonitoringOrder: this.idMonitoringOrder,
        idVehicle: this.vehicle.idVehicle,
        idDriver: this.driver.idDriver,
        idCompany: this.idCompany,
        idTransporter: this.company.idCompany,
      };

      if (this.trailer && this.trailer.licensePlate) {
        params.trailer_plate = this.trailer.licensePlate;
        params.idTrailerTypology = this.trailer.idVehicleTypology;
      }

      await this.axios
        .post(`Travels/AssignTransportCompaniesAndDriversAndVehicles`, params)
        .then(() => {
          this.showSnack({
            text: this.$t(
              "components.views.trip.no_offer_assign.modal_assign.assignment_successful"
            ),
            title: this.$t("components.views.trip.no_offer_assign.modal_assign.success"),
            name: "success",
          });
        })
        .catch((error) => {
          this.showSnack({
            text: error.response.data,
            title: this.$t(
              "components.views.trip.no_offer_assign.modal_assign.assignment_not_possible"
            ),
            name: "error",
          });
        })
        .finally(() => {
          this.valida = true;
          this.$emit("reloadPage");
          this.showLoader({
            show: false,
          });
        });
    },

    async showTypeVehicle() {
      if (!this.vehicle) {
        this.typology = "";
        return;
      }
      let idVehicleTypology =
        this.vehicle.idVehicleTypology == null ? "0" : this.vehicle.idVehicleTypology;
      await this.axios.get(`/Vehicles/typology/${idVehicleTypology}`).then((result) => {
        this.typology = result.data;
      });
    },

    async showGpsVehicle() {
      if (!this.vehicle) {
        this.gps = {};
        return;
      }
      let licensePlate = this.vehicle.licensePlate == null ? "0" : this.vehicle.licensePlate;
      await this.axios.get(`/Vehicles/gps/${licensePlate}`).then((result) => {
        this.gps = result.data;
      });
    },

    onOpenFormDriver() {
      this.dialogDriver = true;
    },

    onCloseFormDriver() {
      this.dialogDriver = false;
    },

    async onDriverCreated(data) {
      if (data) {
        this.dataProp.identification_driver = data;
        await this.$refs.driver.loadData();
      }
    },

    loadModalNewDriver() {
      let driver = this.driverCreate;
      this.driverCapture = driver;
      this.onOpenFormDriver();
    },

    onOpenFormVehicle() {
      this.dialogVehicle = true;
    },

    onCloseFormVehicle() {
      this.dialogVehicle = false;
    },

    async onVehicleCreated(data) {
      if (data) {
        await this.$refs.vehicle.loadData();
      }
    },

    loadModalNewVehicle() {
      this.index++;
      let vehicle = this.vehicleCreate;
      this.vehicleCapture = vehicle;
      this.onOpenFormVehicle();
    },

    onOpenFormTrailer() {
      this.dialogTrailer = true;
    },

    onCloseFormTrailer() {
      this.dialogTrailer = false;
    },

    async onTrailerCreated(data) {
      if (data) {
        await this.loadAllVehicles();
      }
    },

    loadModalNewTrailer() {
      this.index++;
      let trailer = this.trailerCreate;
      this.trailerCapture = trailer;
      this.onOpenFormTrailer();
    },

    async validateDriverCertificate() {
      if (!this.driver || !this.driver.idDriver) {
        return;
      }

      try {
        const response = await this.axios.get(`/Drivers/validateDriver/${this.driver.idDriver}`);
        const validateData = response.data;
        // Validar documentos: vencidos o sin fecha
        const documents = Array.isArray(validateData.documentList) ? validateData.documentList : [];
        if (documents.length > 0) {
          const today = new Date();
          const expiredDocs = documents.filter(doc => {
            if (!doc) return false;
            // Considerar sin fecha como vencido en el flujo actual
            if (!doc.dateExpiration) return true;
            const exp = new Date(doc.dateExpiration);
            return !isNaN(exp.getTime()) && exp < today;
          });

          const docsWithoutDate = documents.filter(doc => doc && !doc.dateExpiration);

          // Caso 1: documentos vencidos o sin fecha (comportamiento existente)
          if (expiredDocs.length > 0) {
            this.showDriverValidationAlert(validateData, expiredDocs);
          } else {
            // Caso 2: certificado inactivo y hay documentos sin fecha
            if (!validateData.certificate && docsWithoutDate.length > 0) {
              this.showDriverValidationAlert(validateData, docsWithoutDate);
            }
          }
        }
      } catch (error) {
        console.error('Error validating driver:', error);
        this.showSnack({
          text: 'Error de validación',
          title: 'Error al validar el conductor',
          name: 'error',
        });
      }
    },

    async showDriverValidationAlert(validateData, expiredDocs) {
      try {
        const driverName = `${validateData.name} ${validateData.lastName}`;
        this.docsAlertData = { driverName, documents: expiredDocs };
        this.dialogDocsAlert = true;
      } catch (error) {
        console.error('Error in showDriverValidationAlert:', error);
        this.showSnack({
          text: 'Error en la validación del conductor',
          title: 'Error',
          name: 'error'
        });
        this.driver = null;
      }
    },

    onCloseDocsAlert() {
      this.dialogDocsAlert = false;
      this.driver = null;
      this.driverName = "";
      this.dataProp.driver_name = "";
    },

    formatExpirationDate(expirationDate) {
      if (!expirationDate) {
        return 'fecha no disponible';
      }

      const date = new Date(expirationDate);

      if (isNaN(date.getTime())) {
        return 'fecha no disponible';
      }

      // Formatear fecha manualmente DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    async loadAllVehicles() {
      try {
        const response = await this.axios.get('/Vehicles');
        this.allVehicles = response.data || [];
      } catch (error) {
        console.error('Error loading vehicles:', error);
        this.allVehicles = [];
      }
    },
  },
};
</script>

<style scoped>
.title--text {
  font-size: 20px;
}

#card-modal-assign-vehicle {
  border: 3px solid #0b0045 !important;
  height: 480px;
}

.v-divider {
  border-width: 1px !important;
}

#card-modal-assign-vehicle p {
  font-size: 1.17em !important;
}

.cont {
  position: absolute;
  right: 10px;
}

#stateGPSColor {
  display: block;
  width: 100%;
  text-align: center;
  height: 23px;
  padding-top: 1px;
  border-radius: 10px;
}

#info_gps {
  font-size: 0.9em;
}

.card-modaltitle {
  border-bottom: 1px solid #ccc;
}

.contaaner__btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
